<template>
  <div class="mx-auto">
    <h2 class="text-lg text-gray-700 font-medium mb-4">NEW MESSAGE</h2>

    <form @submit.prevent="sendMessage">
      <div class="mb-4">
        <input
            v-model="subject"
            type="text"
            class="border border-gray-400 p-2 w-full rounded-lg focus:outline-none focus:border-blue-400"
            placeholder="Subject *"
            required
        />
      </div>

      <div class="mb-4">
        <textarea
            v-model="body"
            class="border border-gray-400 p-2 w-full rounded-lg focus:outline-none focus:border-blue-400"
            placeholder="Message *"
            rows="5"
            required
        ></textarea>
      </div>

      <div class="flex justify-center gap-x-2">
        <div class="relative w-1/4">
          <input
              type="file"
              id="file-upload"
              class="hidden"
              @change="handleFile"
          />
          <label
              for="file-upload"
              class="w-full h-full cursor-pointer inline-flex items-center justify-center gap-2 px-4 py-2 bg-white text-primary font-medium text-sm rounded-lg shadow hover:bg-primary/90 transition"
          >
            Attach
          </label>
          <p v-if="fileName" class="mt-2 text-sm text-gray-700">
            Selected: <span class="font-semibold">{{ fileName }}</span>
          </p>
        </div>

        <button
            type="submit"
            class="w-1/4 flex items-center justify-center gap-1 bg-primary text-white px-4 py-2 rounded-lg"
        >
          SEND
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref,defineEmits } from "vue"
import api from "@/services/api";

const subject = ref("")
const body = ref("")
const fileName = ref("")
const file = ref(null)

const emit = defineEmits(["refresh"])

const handleFile = (event) => {
  file.value = event.target.files[0]
  fileName.value = file.value ? file.value.name : ""
}

const sendMessage = async () => {
  const formData = new FormData()
  formData.append("subject", subject.value)
  formData.append("body", body.value)
  if (file.value) {
    formData.append("attachment", file.value)
  }

  await api.post("/messages", formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  })

  subject.value = ""
  body.value = ""
  fileName.value = ""
  file.value = null
  emit("refresh")
}
</script>
